import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

/**
 * BRPoints theme — valores hex idênticos ao mapa de cores existente.
 * Centraliza tokens para componentes Vuetify (color="primary", etc.).
 */
export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#e5183d',
        secondary: '#242968',
        accent: '#c41e3a',
        error: '#e5183d',
        info: '#242968',
        success: '#24a859',
        warning: '#d97706',
        anchor: '#e5183d',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
